import type {
  TopologyEdgeSourceDescriptorFactoryInput,
} from '../../../../../types/reference/sketch-entity-reference/TopologyEdgeSourceDescriptorFactory';
import type {
  TopologyEdgeSourceDescriptor,
} from '../../model/ExternalGeometrySourceDescriptor';

/**
 * 当前 topology edge 候选到持久来源描述的统一工厂。
 */
export class TopologyEdgeSourceDescriptorFactory {
  /**
   * @inheritdoc
   */
  public create(
    input: TopologyEdgeSourceDescriptorFactoryInput,
  ): TopologyEdgeSourceDescriptor {
    const hasSampledCurve = Boolean(
      input.edge.sampledPointWorlds
      && input.edge.sampledPointWorlds.length >= 2,
    );
    const isExactLine = input.edge.curveKind === 'line' && Boolean(input.edge.worldLine);
    return {
      kind: 'topology-edge',
      owner: {
        ...structuredClone(input.owner),
        ...(input.edge.topologyMemberId
          ? { resultObjectId: input.edge.topologyMemberId }
          : {}),
      },
      ...(input.originSelectionIntentId
        ? { originSelectionIntentId: input.originSelectionIntentId }
        : {}),
      locator: {
        edgeIndex: input.edge.edgeIndex,
        semanticName: input.edge.semanticName,
        persistentRef: input.edge.persistentRef,
        subEntityId: input.edge.subEntityId,
        curveKind: input.edge.curveKind,
        resolutionLevel: isExactLine || Boolean(input.edge.exactConic)
          ? 'exact'
          : hasSampledCurve
            ? 'sampled-only'
            : 'unsupported',
        geomFingerprint: isExactLine && input.edge.worldLine
          ? {
              kind: 'line',
              startWorld: [...input.edge.worldLine.start],
              endWorld: [...input.edge.worldLine.end],
            }
          : undefined,
        matchHints: {
          adjacentFaceRefs: input.edge.owningFaceRefs
            ? [...input.edge.owningFaceRefs]
            : undefined,
          adjacentFaceSubEntityIds: input.edge.adjacentFaceSubEntityIds
            ? [...input.edge.adjacentFaceSubEntityIds]
            : undefined,
        },
      },
    };
  }
}
